import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  static values = {
    slug: String
  }

  async dismiss(event) {
    event.preventDefault()

    if (!this.hasSlugValue) return

    try {
      await post('/prompt_dismissals', {
        body: JSON.stringify({ slug: this.slugValue })
      })
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('Failed to dismiss prompt', error)
      }
    }
  }
}

